'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '入力されたEメールアドレスは不正なアドレスです';